module.exports = __webpack_public_path__ + "static/media/adsumlogo.07a8e8e8.png";